import { createSlideIcon, type IconProps } from '../SlideTypeIcon';

const DEFAULT_COLOR = 'var(--palette-yellow-700)';

const Icon24x24 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path
      d="M12 16C10.8954 16 10 16.8954 10 18C10 19.1046 10.8954 20 12 20C13.1046 20 14 19.1046 14 18C14 16.8954 13.1046 16 12 16Z"
      fill={textColor}
    />
    <path
      d="M12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z"
      fill={textColor}
    />
    <path
      d="M12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4Z"
      fill={textColor}
    />
  </>
);

const Icon32x32 = ({ textColor = DEFAULT_COLOR }: IconProps) => (
  <>
    <path
      d="M16 20.7998C14.4978 20.7998 13.28 22.0176 13.28 23.5198C13.28 25.022 14.4978 26.2398 16 26.2398C17.5022 26.2398 18.72 25.022 18.72 23.5198C18.72 22.0176 17.5022 20.7998 16 20.7998Z"
      fill={textColor}
    />
    <path
      d="M16 13.2798C14.4978 13.2798 13.28 14.4976 13.28 15.9998C13.28 17.502 14.4978 18.7198 16 18.7198C17.5022 18.7198 18.72 17.502 18.72 15.9998C18.72 14.4976 17.5022 13.2798 16 13.2798Z"
      fill={textColor}
    />
    <path
      d="M16 5.75977C14.4978 5.75977 13.28 6.97755 13.28 8.47977C13.28 9.98198 14.4978 11.1998 16 11.1998C17.5022 11.1998 18.72 9.98198 18.72 8.47977C18.72 6.97755 17.5022 5.75977 16 5.75977Z"
      fill={textColor}
    />
  </>
);

export const BulletsIcon = createSlideIcon(Icon24x24, Icon32x32);
